import { queryOptions } from "@tanstack/react-query"
import { request } from "@utils/request"

import { ERRORS_API_BASE } from "./-enabled"

export type ErrorReport = {
  id: number
  ts: number
  timestamp: number
  level: "error" | "warning" | "info"
  message: string
  solutionUid: string
  userUid: string
  context: {
    url: string
    userAgent: string
    stack?: string
    componentStack?: string
    appName: string
    appVersion: string
  }
}

export type ListResponse = {
  items: ErrorReport[]
}

export const API_LIST_LIMIT = 20_000

export const isTruncated = (list: ListResponse): boolean =>
  list.items.length >= API_LIST_LIMIT

export const MONTH_WINDOWS = [1, 2, 3] as const

export type MonthWindow = (typeof MONTH_WINDOWS)[number]

export const DEFAULT_MONTH_WINDOW: MonthWindow = 1

export type Range = {
  from: number
  to: number
}

export const monthRange = (
  months: MonthWindow,
  now: Date = new Date(),
): Range => {
  const from = new Date(now)
  from.setDate(1)
  from.setMonth(from.getMonth() - months)
  const daysInMonth = new Date(
    from.getFullYear(),
    from.getMonth() + 1,
    0,
  ).getDate()
  from.setDate(Math.min(now.getDate(), daysInMonth))
  return { from: from.getTime(), to: now.getTime() }
}

export const isMonthWindow = (value: unknown): value is MonthWindow =>
  MONTH_WINDOWS.some((month) => month === value)

export const errorReports = (months: MonthWindow) =>
  queryOptions({
    queryKey: ["errors", "list", months],
    queryFn: () => {
      const { from, to } = monthRange(months)
      return request
        .get(`${ERRORS_API_BASE}/list`, {
          searchParams: { from, to },
          prefix: "",
          credentials: "include",
        })
        .json<ListResponse>()
    },
  })
